// src/components/layout/Navbar.jsx
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { useTheme } from '../../context/ThemeContext'; // IMPORTS THE THEME HOOK

const Navbar = () => {
    const { theme } = useTheme(); // GETS THE THEME FROM CONTEXT
    const location = useLocation(); // Gets the current URL location
    const navigate = useNavigate(); // Gets the function to navigate programmatically

    // Determine if the current theme resolves to dark mode
    const isDarkMode = theme === 'dark' || (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);

    const handleGetAccessClick = () => {
        // Fires the Google Analytics event every time
        ReactGA.event({
            category: 'User',
            action: 'Clicked Get Early Access',
            label: `From page: ${location.pathname}`
        });

        // Checks if the location is homepage
        if (location.pathname === '/') {
            // If yes, just finds the form and scroll smoothly
            const formSection = document.getElementById('early-access');
            formSection?.scrollIntoView({ behavior: 'smooth', block: 'end' });
        } else {
            // If on another page (like /blog), navigate to the homepage with a hash, the browser will then jump to the form section.
            navigate('/#early-access');
        }
    };

    return (
        <nav className="fixed top-0 left-0 w-full bg-white/80 dark:bg-[#191919]/80 backdrop-blur-md z-50 border-b border-gray-300/50 dark:border-[#2A2A2A]/50 px-8 py-3">
            <div className="flex items-center justify-between">
                <Link to="/" id="logo" className="relative flex items-center">
                    <img
                        id="blackLogo"
                        className={`h-10 transition-all duration-300 ${isDarkMode ? 'hidden' : ''}`}
                        src="/static/logo/trueway - black.svg"
                        alt="Trueway black logo"
                    />
                    <img
                        id="whiteLogo"
                        className={`h-10 transition-all duration-300 ${isDarkMode ? '' : 'hidden'}`}
                        src="/static/logo/trueway - white.svg"
                        alt="Trueway white logo"
                    />
                </Link>

                <div className="flex space-x-4">
                    <button
                        onClick={handleGetAccessClick}
                        className="px-3 py-1 rounded-lg text-sm bg-stone-200 dark:bg-stone-800 text-black dark:text-stone-100 hover:bg-stone-300 dark:hover:bg-stone-700 active:bg-stone-400 dark:active:bg-stone-600 dark:border dark:border-stone-600 transform ease-in-out duration-300"
                    >
                        Get early access
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;